module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+Cgk8cGF0aCBkPSJNMTEuNDEsMTBsNy4yOS03LjI5YTEsMSwwLDAsMC0xLjQxLTEuNDFMMTAsOC41OSwyLjcxLDEuMjlBMSwxLDAsMCwwLDEuMjksMi43MUw4LjU5LDEwLDEuMjksMTcuMjlhMSwxLDAsMSwwLDEuNDEsMS40MUwxMCwxMS40MWw3LjI5LDcuMjlhMSwxLDAsMCwwLDEuNDEtMS40MVoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/close.svg
// module id = WlY0
// module chunks = 0